export const REFUND_ADMIN_ROLES = ['SUPER_ADMIN', 'REFUND_ADMIN'] as const;

export const hasRefundAdminRole = (roles?: ReadonlyArray<string> | null): boolean =>
  Boolean(
    roles?.some(role => REFUND_ADMIN_ROLES.includes(role as (typeof REFUND_ADMIN_ROLES)[number])),
  );

export const hasRestrictedBrandCollectionAccess = (
  roles?: ReadonlyArray<string | undefined> | null,
): boolean => Boolean(roles?.includes('BRAND_MANAGER') && !roles.includes('ONLINE_MERCH'));
